import { getFilterTravelPreference } from "pages/private/TripSelector/TripSelector.util";

declare const window: any;

//Todos los datos de las rutas (izquierda)
export function dataLayerViewItemList(passengersList: any, filteredTrips: any, mapedDetail: any, filterTrip?: any, screenName?: any, typeTrip?: any) {
  try {
    //let view_item_list: any[] = []
    let lengthResumen = mapedDetail.length;
    let oIzq = "", dIzq = "";

    oIzq = mapedDetail[0]?.trip.Origin.name;
    dIzq = mapedDetail[lengthResumen - 1]?.trip.Destination.name;
    let totalPassengers = passengersList?.["less-than-3-counter"] + passengersList?.["less-than-13-counter"] + passengersList?.["more-than-13-counter"];


    filteredTrips.map((item: any, index: any) => {

      /*const element = {};*/
      window.dataLayer?.push({
        event: "view_item_list",
        item_list_id: "SR" + index,
        item_list_name: "t:" + typeTrip + "_o:" + oIzq + "_d:" + dIzq + "_",
        screen_class: "trip_result",
        screen_name: screenName,
        journey_origin: 'home',
        journey_search: 'home',
        items: {
          //item_id: item.trasportSection.map((i: any) => i.icon).toString(),
          item_name: item.trasportSection.map((i: any) => i.icon === "andar" ? "Tramo a pie" : i.transportTypeString).toString(),
          item_category: "t:" + screenName + "_f:" + preferenceSearchDataLayer(filterTrip) + "_",
          item_brand: filteredTrips[index]?.trip.LegList?.Leg[0]?.name,
          item_category2: typeTrip,
          item_category3: mapedDetail.map((i: any) => "o:" + i.trip.Origin.name + "_d:" + i.trip.Destination.name + "_").toString(),
          item_category4: "_time:" + item.departureTime.substring(0, 5) + "_date:" + mapedDetail[0]?.trip?.Origin?.date.replace(/-/g, "") + "_",
          item_category5: "_time:" + item.departureTime.substring(8, 13) + "_date:" + mapedDetail[lengthResumen - 1]?.trip?.Destination?.date.replace(/-/g, "") + "_",
          price: item.price === "- €" ? "0" : item.price.replace(/[^0-9,]+/g, ""),
          currency: "EUR",
          quantity: totalPassengers.toString(),
        }
      });
      //view_item_list.push(element);
    });

    /*window.dataLayer?.push({
      event: "view_item_list",
      item_list_name: "t:" + typeTrip + "_o:" + oIzq + "_d:" + dIzq + "_",
      screen_class: "trip_result",
      screen_name: screenName,
      items: view_item_list,
    });*/

  } catch (error) {
    console.warn('error en dataLayerViewItemList ', error);
  }
}

//Datos del detalle de la ruta (derecha)
export function dataLayerViewItem(passengersList: any, mapedDetail: any, filterTrip?: any, detailPrice?: any, isReturnTrip?: any, returnStep?: any, trip?: any, index?:any) {
  try {
    let summaryData: any[] = []


    let totalPassengers = passengersList?.["less-than-3-counter"] + passengersList?.["less-than-13-counter"] + passengersList?.["more-than-13-counter"];
    let transportPrice = 0, detailId = "";

    mapedDetail?.forEach((element: any) => {
      transportPrice = transportPrice + element.pricetag.price
      detailId = element.idPst
    });

    mapedDetail.map((item: any, index: any) => {
      const data = {
        
        item_id: item?.idPst,
        item_name:mappingItemNameDataLayer(item.transportTypeString,item.trip?.name),
        item_category: "t:" + typeTripDisplayedScreen(isReturnTrip, returnStep) + "_f:" + preferenceSearchDataLayer(filterTrip) + "_",
        item_brand: item?.trip.name.toString(),
        item_category2: typeTripDataLayer(isReturnTrip),
        item_category3: "o:" + item.trip.Origin.name + "_d:" + item.trip.Destination.name + "_",
        item_category4: "_time:" + item.departureTime + "_date:" + item.departureDate.replace(/-/g, "") + "_",
        item_category5: "_time:" + item.arrivalTime + "_date:" + item.trip.Destination.date.replace(/-/g, "") + "_",
        price: item?.pricetag?.price?.toString(),
        //currency: "EUR",
        quantity: totalPassengers.toString()

      };
      summaryData.push(data);
    });
    if (mapedDetail.length != 0 && detailPrice?.desc != undefined) {
      window.dataLayer?.push({
        currency: "EUR",
        item_list_id: "SR" + index,
        value:convertPriceNumber( detailPrice?.desc),
        item_list_name: "t:" + typeTripDataLayer(isReturnTrip) + "_o:" + trip.Origin.name + "_d:" + trip.Destination.name + "_",
        screen_class: "trip_detail",
        screen_name: typeTripDisplayedScreen(isReturnTrip, returnStep),
        items: summaryData,
        event: "view_item",
        journey_origin: 'home',
        journey_search: 'home'
      });
    }
  } catch (error) {
    console.warn('error en dataLayerViewItem ', error);
  }

}

//Al seleccionar una ruta (izquierda)
export function dataLayerSelectItem(trip: any, filteredTrips?: any, mapSummaryInfo?: any, index?: any, isReturnTrip?: any, returnStep?: any, filterTrip?: any, mapedDetail?: any) {
  try {
    if (filteredTrips.length != 0) {
      let summaryData: any[] = []
      mapedDetail.map((item: any, index: any) => {
      const data = {
        item_name:mappingItemNameDataLayer(item.transportTypeString,item.trip?.name),
        item_category: "t:" + typeTripDisplayedScreen(isReturnTrip, returnStep) + "_f:" + preferenceSearchDataLayer(filterTrip) + "_",
        item_brand: item.trip?.name,
        item_category2: typeTripDataLayer(isReturnTrip),
        item_category3: "o:" + item.trip.Origin.name + "_d:" + item.trip.Destination.name + "_",
        item_category4: "_time:" + trip.Origin.time + "_date:" + trip.Origin.date.replace(/-/g, "") + "_",
        item_category5: "_time:" + trip.Destination.time + "_date:" + trip.Destination.date.replace(/-/g, "") + "_",
        price: trip.price === "- €" ? "0" : trip.price.replace(/[^0-9,]+/g, "").toString(),
        //currency: "EUR",
        quantity: mapSummaryInfo.travellers.toString()
      }
      summaryData.push(data)
    });
      window.dataLayer?.push({
        item_list_id: "SR" + index,
        item_list_name: "t:" + typeTripDataLayer(isReturnTrip) + "_o:" + trip.Origin.name + "_d:" + trip.Destination.name + "_",
        screen_class: "trip_result",
        screen_name: typeTripDisplayedScreen(isReturnTrip, returnStep),
        event: "select_item",
        items: summaryData,
        journey_origin: 'home',
        journey_search: 'home'
      });

    }
  } catch (error) {
    console.warn('error en dataLayerSelectItem ', error);

  }

}


export function dataLayerAddToCart(trip: any, filteredTrips?: any, mapSummaryInfo?: any, index?: any, isReturnTrip?: any, returnStep?: any, filterTrip?: any,price?:any) {
  try {
    if (filteredTrips.length != 0) {
      let addToData: any[] = []
      filteredTrips[index]?.trasportSection.map((item: any, index: any) => {
        const data = {
          item_name:item.icon === "andar" ? "Walk" : item.transportTypeString.toString(),
          //item_name: filteredTrips[index]?.trasportSection.map((i: any) => i.icon === "andar" ? "Tramo a pie" : i.transportTypeString).toString(),//añadido to string prueba
          item_category: "t:" + typeTripDisplayedScreen(isReturnTrip, returnStep) + "_f:" + preferenceSearchDataLayer(filterTrip) + "_",
          item_brand: filteredTrips[index]?.trip?.LegList?.Leg[0]?.name,
          item_category2: typeTripDataLayer(isReturnTrip),
          item_category3: "o:" + trip.Origin.name + "_d:" + trip.Destination.name + "_",
          item_category4: "_time:" + trip.Origin.time + "_date:" + trip.Origin.date.replace(/-/g, "") + "_",
          item_category5: "_time:" + trip.Destination.time + "_date:" + trip.Destination.date.replace(/-/g, "") + "_",
          //price: filteredTrips[index]?.price === "- €" ? "0" : filteredTrips[index]?.price.replace(/[^0-9,]+/g, ""),
          quantity: mapSummaryInfo.travellers,
          
          
        }
        addToData.push(data)
      });
      window.dataLayer?.push({
        currency: "EUR",
        value: price?.sum,
        item_list_id: "SR" + index,
        screen_name: typeTripDisplayedScreen(isReturnTrip, returnStep),
        screen_class: "trip_detail",
        event: "add_to_cart",
        item_list_name: "t:" + typeTripDataLayer(isReturnTrip) + "_o:" + trip.Origin.name + "_d:" + trip.Destination.name + "_",
        items: addToData,
        journey_origin: 'home',
        journey_search: 'home'
      });
    }
  } catch (error) {
    console.warn('error en dataLayerAddToCart ', error);

  }
}


export function dataLayerBeginCheckout(tripSelectedDetails?: any, totolPrice?: any, summaryInfo?: any, travelData?: any,typeTripDataLayer?:any) {
  try {
    let beginCheckout: any[] = [];
    let filterTrip = travelData?.outwardJourney?.trip?.Eco?.rating.toString();
    tripSelectedDetails?.summaryAmount?.departure?.transports?.map((item: any, index: any) => {
      const aux = {
        item_name: item?.transport,//Añadido to string
        item_category: "t:" + typeTripDataLayer + "_f:" + preferenceSearchDataLayer(filterTrip) + "_",
        //item_brand: travelData.outwardJourney?.trip?.LegList?.Leg.map((i: any) => i.name).toString(),
        item_brand: travelData.outwardJourney?.trip?.LegList?.Leg[index].name,
        item_category2: typeTripDataLayer,
        item_category3: "o:" + tripSelectedDetails?.outwardJourney?.trip?.Origin?.name + "_d:" + tripSelectedDetails?.outwardJourney?.trip?.Destination?.name + "_",
        item_category4: "_time:" + travelData?.outwardJourney?.trip?.Origin?.time + "_date:" + travelData?.outwardJourney?.trip?.Origin?.date?.replace(/-/g, "") + "_",
        item_category5: "_time:" + travelData?.outwardJourney?.trip?.Destination.time + "_date:" + travelData?.outwardJourney?.trip?.Destination?.date.replace(/-/g, "") + "_",
        //price: item?.price ? item?.price.replace(/[^0-9,]+/g, "") : item?.details[0]?.price.replace(/[^0-9,]+/g, ""),
        quantity: summaryInfo[0]?.num,
        item_list_id: "SR" + index,
      };
      beginCheckout.push(aux);

    }
    );
    if (travelData.travellers) {
      window.dataLayer?.push({
        event: "begin_checkout",
        currency: "EUR",
        value: convertPriceNumber(totolPrice) ,
        item_list_name: "t:" + typeTripDataLayer + "_o:" + travelData?.outwardJourney?.trip.Origin.name + "_d:" + travelData?.outwardJourney?.trip.Destination.name + "_",
        screen_name: typeTripDataLayer,
        screen_class: "trip_cart_resume",
        items: beginCheckout,
        journey_origin: 'home',
        journey_search: 'home'
      });
    }
  } catch (error) {
    console.warn('error en dataLayerBeginCheckout ', error);
  }


}


export function dataLayerPurchase(tripSelectedDetails?: any, totolPrice?: any, summaryInfo?: any, travelData?: any, response?: any,typeTripDataLayer?:any) {
  try {
    let purchase: any[] = [];
    tripSelectedDetails?.summaryAmount?.departure?.transports?.map((item: any, index: any) => {
      const aux = {
        //item_brand: tripSelectedDetails.body.outwardJourney.trip.LegList.Leg.map((i: any) => i.name).toString(),
        item_name: tripSelectedDetails?.summaryAmount?.departure?.transports.map((i: any) => i.transport).toString(),//Añadido to string
        item_category: "t:" + typeTripDataLayer + "_f:" + preferenceSearchDataLayer(getFilterTravelPreference()) + "_",
        item_brand: tripSelectedDetails.body.outwardJourney.trip.LegList.Leg[index].name,
        item_category2: typeTripDataLayer,
        item_category3: "o:" + summaryInfo[0].departure + "_d:" + summaryInfo[0].arrival + "_",
        item_category4: "_time:" + travelData?.outwardJourney?.trip?.Origin.time + "_date:" + travelData?.outwardJourney?.trip?.Origin.date.replace(/-/g, "") + "_".toString(),
        item_category5: "_time:" + travelData?.outwardJourney?.trip?.Destination.time + "_date:" + travelData?.outwardJourney?.trip?.Destination.date.replace(/-/g, "") + "_".toString(),
        //price: item?.price ? item?.price.replace(/[^0-9,]+/g, "") : item?.details[0]?.price.replace(/[^0-9,]+/g, ""),
        quantity: summaryInfo[0]?.num,
        //item_id: item.transport,
        item_list_id: "SR" + index,
      };
      purchase.push(aux);

    }
    );

    window.dataLayer?.push({
      screen_name: "purchase_confirm",
      screen_class: "trip_confirm",
      item_list_name: "t:" + typeTripDataLayer + "_o:" + travelData?.outwardJourney?.trip.Origin.name + "_d:" + travelData?.outwardJourney?.trip.Destination.name + "_",
   
      event: "purchase",
      currency: "EUR",
      value: convertPriceNumber(totolPrice),
      transaction_id: response?.data?.tripId, // devuelto del back
      items: purchase,
      journey_origin: 'home',
      journey_search: 'home'

    });

  } catch (error) {
    console.warn('error en dataLayerPurchase ', error);
  }
}

function mappingItemNameDataLayer(name: string, brand:string) {
  let result="";
  switch (brand) {
    case 'Ingreso':
      result="Ingreso"
      break;

      case 'Trayecto a pie':
      result="Walk"
      break;  
  
    default:
      result= name
      break;
  }
return result

}

function convertPriceNumber(price: string) {
  try {
    let result
    let removeExcess=price.replace(/[^0-9,]+/g, "");
    result=removeExcess.replace(",",".");
    return parseFloat(result)
  } catch (error) {
    console.warn('error en convertPriceNumber ', error);
  }

}

function typeTripDataLayer(isReturnTrip: boolean) {
  try {
    let result = "oneway";
    if (isReturnTrip === true) {
      result = "round";
    }
    return result
  } catch (error) {
    console.warn('error en typeTripDataLayer ', error);
  }
}


function typeTripDisplayedScreen(isReturnTrip: boolean, returnStep: number) {
  try {
    let result = "";
    if (isReturnTrip == false) {
      result = "oneway";
    } else {
      //ida
      if (returnStep == 0) {
        result = "departure";
        // vuelta  
      } else if (returnStep == 1 || returnStep == 2) {
        result = "arrival";
      }
    }
    return result
  } catch (error) {
    console.warn('error en typeTripDisplayedScreen ', error);

  }
}

export function preferenceSearchDataLayer(filterTrip: any) {
  try {
    let result = "";
    switch (filterTrip) {
      case '0':
        result = "fast";
        break;
      case '1':
        result = "economic";
        break;
      case '2':
        result = "eco";
        break;
      default:
        break;
    }
    return result
  } catch (error) {
    console.warn('error en preferenceSearchDataLayer ', error);
  }
}

export function mappingScreenNameAnalytics(url: string) {
  // let result=url.substring(5,url.length);
  let path = url.split('/'); // ["app", "my-trips"]
  let result = path[path.length-1]; // Cojo el ultimo item del array.
  switch (result) {
    case 'my-trips':
      result="trips";
    break;
    case 'my-profile':
      result="profile";
    break;
    default:
      result=result;
    break;
  }

  return result;
}

export function mappingTMBAnalytics(cadena:any) {
  let result="",typeCard="";
  switch (cadena) {
    case 'holabarcelona-travel-card':
      result="travel_card_bcn";
      typeCard="tarvel_card_";
    break;
    case 'barcelona-bus-turist':
      result="turistic_bus_bcn";
      typeCard="turistic_bus_";
    break;
    case 'montjuic-cable-car':
      result="teleferico_bcn";
      typeCard="detail_teleferico_bcn "
    break;
  default:
    break;
}
return {result,typeCard}
}

export function mappingTMBScrenNameAnalytics(name:any) {
  let result=""
if(name.includes('24')){
  result="1"
}else if(name.includes('48')){
  result="2"
}else if(name.includes('72')){
  result="3"
}else if(name.includes('96')){
  result="4"
}else if(name.includes('120')){
  result="5"
}
return result
}